module.exports = __webpack_public_path__ + "static/about-photo-509fbaf38610258592d5aab23a26c2b2.jpg";